import type * as React from 'react';

import { MAX_INVITE_EMAILS } from '@gitbook/app-database';
import { Alert } from '@gitbook/spine-react';

import { useContactSupport } from '../../state';

/** Alert directing users to support when they reach the email invite limit. */
export function BulkInviteLimitAlert(props: { emailCount: number }): React.ReactElement | null {
    const contactSupport = useContactSupport();

    if (props.emailCount < MAX_INVITE_EMAILS) {
        return null;
    }

    return (
        <Alert
            kind="info"
            size="xsmall"
            details="Need to invite many users? We can help!"
            action={{
                label: 'Contact support',
                onPress: () => contactSupport(),
            }}
        />
    );
}
